import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import authToken from "./../token/Token";
import { servicesApi } from "./../API/api";

const Create_services = () => {
  const [serviceName, setserviceName] = useState("");
  const [serviceUrl, setserviceUrl] = useState("");
  const [iconUrl, seticonUrl] = useState(null);
  const history = useHistory();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    seticonUrl(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("service_name", serviceName);
    formData.append("service_url", serviceUrl);
    formData.append("icon_url", iconUrl);

    fetch(servicesApi, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Create successful:", data);
        history.push("/components/services");
      })
      .catch((error) => {
        console.error("Error creating data:", error.message);
      });
  };

  return (
    <section className="wrap-section-1">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 bg-white">
            <h3 className="fw-bold">Create services</h3>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="serviceName">
                <Form.Label>Service Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Service Name"
                  value={serviceName}
                  onChange={(e) => setserviceName(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="serviceUrl">
                <Form.Label>Service URL</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Service URL"
                  value={serviceUrl}
                  onChange={(e) => setserviceUrl(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="iconUrl">
                <Form.Label>Icon</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  required
                />
              </Form.Group>

              <Button variant="warning" type="submit">
                Create
              </Button>
              <Link
                to="/components/services"
                className="btn btn-secondary ms-2"
              >
                Cancel
              </Link>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Create_services;
